export { VLocaleProvider } from './VLocaleProvider'
